/**
 * Gestionnaire global pour les erreurs de session expirée
 * Fonctionne avec Livewire - très léger, s'active uniquement lors des requêtes
 */

// Gestionnaire pour les erreurs Livewire
// Note: Ce hook ne consomme AUCUNE ressource tant qu'il n'y a pas de requête Livewire
document.addEventListener('livewire:init', () => {
    Livewire.hook('request', ({ fail }) => {
        fail(({ status, preventDefault }) => {
            if (status === 419) {
                preventDefault();
                console.warn('Session Livewire expirée, rechargement de la page...');
                window.location.reload();
            }
        });
    });
});

